const holder = (props) => props.children;

export default holder;